import React, { useState } from "react";
import CisList from "./CisList";
import LoadSimple from "../LoadSimple";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const TableCis = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,  
  setContRowSelected,
  poolRows,setPoolRows,
  handleShowPopup,view,
  setPoolObjectRows,buscar_cis,userPermissions,
  mode
  
}) => {
  const [allSelected, setAllSelected] = useState(false);
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.id);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.id);
      } else {
        return [...prevRows, elemento.id];
        
      }
    });
    setPoolObjectRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.id);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.id);
      } else {
        return [...prevRows, elemento];
        
      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      // Si no, selecciona todos los elementos
      // setPoolRows(dataList
      //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList)));
        // setPoolRows(dataList);
        setPoolRows(dataList.map(item => item.id))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
        <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div>
        <div className="field-head-table-cis field-medium">CI-ID</div>
        <div className="field-head-table-cis field-medium">Host IP</div>
        {/* <div className="field-head-table-cis field-larger">{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</div> */}
        <div className="field-head-table-cis field-larger" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
        <div className="field-head-table-cis field-larger">{'Servicios'}</div>
        {/* <div className="field-head-table-cis field-small">{capitalizeFirstLetter(lang[languaje]['evento'])}</div>
        <div className="field-head-table-cis field-small">{'Incidente'}</div> */}
        <div className="field-head-table-cis field-larger">{'Zona'}</div>
        <div className="field-head-table-cis field-larger">{'Afiliación'}</div>
        <div className="field-head-table-cis field-larger">{'Grupo CI'}</div>
         <div className="field-head-table-cis field-medium">Status</div>
         <div className="field-head-table-cis field-small">Evento</div>
        {/* <div className="field-head-table-cis field-small">{capitalizeFirstLetter(lang[languaje]['criticidad'])}</div>
        <div className="field-head-table-cis field-medium">Status</div>
        <div className="field-head-table-cis field-medium">Status Conf.</div> */}

        <div className="field-head-table-cis field-larger">{capitalizeFirstLetter(lang[languaje]['acciones'])}</div>
        </div>
      </div>
      <div className="body-table-cis-gs">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <CisList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            handleShowPopup={handleShowPopup}
            view={view}
             setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            buscar_cis={buscar_cis}
            userPermissions={userPermissions}
          ></CisList>
        )}
      </div>
    </div>
  );
};

export default TableCis;
